const BarchartSkeleton = () => {
  return (
    <div className="p-4 w-full h-full bg-secondary-skeleton rounded-lg flex justify-center items-center animate-pulse">
      <div className="w-full h-full bg-secondary-skeleton rounded-lg"></div>
    </div>
  )
}

export default BarchartSkeleton
